import { Component } from '@angular/core';

import { TranslatePipe } from '@core/i18n-legacy';
import { IconComponent, RtTooltip } from '@core/user-interface-legacy';

@Component({
  selector: 'rt-requisition-only-icon',
  imports: [IconComponent, RtTooltip, TranslatePipe],
  templateUrl: './requisition-only-icon.component.html',
})
export class RequisitionOnlyIconComponent {}
